import { PageHeader } from "@/components/layout/PageHeader";
import { Button } from "@repo/ui/primitives/button";
import { StatusBadge } from "@repo/ui/primitives/status-badge";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

export default function NotFoundPage({ breadcrumb, embedded }) {
  const { t } = useTranslation("notFound");
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    navigate("/home", { replace: true });
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home", { replace: true });
    }
  };

  const content = (
    <div className="flex min-h-[320px] items-center justify-center rounded-[var(--ds-radius-surface)] border border-border bg-card p-[var(--ds-space-8)] shadow-[var(--shadow-surface)]">
      <div className="max-w-xl space-y-[var(--ds-space-6)] text-center">
        <div className="space-y-[var(--ds-space-2)]">
          <StatusBadge variant="info" className="mx-auto w-fit font-mono text-xs uppercase tracking-wide">
            404
          </StatusBadge>
          <h2 className="text-2xl font-semibold tracking-tight text-foreground">
            {t("message.headline", { defaultValue: "We couldn't find this page." })}
          </h2>
          <p className="text-sm text-muted-foreground">
            {t("message.hint", { defaultValue: "Check the URL, or use the navigation menu to find what you are looking for." })}
          </p>
          <p className="mt-1 text-xs text-muted-foreground/80 break-all">
            <code>{location.pathname}</code>
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-[var(--ds-space-control-gap)]">
          <Button onClick={handleGoHome}>{t("actions.goHome", { defaultValue: "Go to dashboard" })}</Button>
          <Button variant="outline" onClick={handleGoBack}>
            {t("actions.goBack", { defaultValue: "Go back" })}
          </Button>
        </div>
      </div>
    </div>
  );

  if (embedded) {
    return content;
  }

  return (
    <>
      <PageHeader
        title={t("page.title", { defaultValue: "Page not found" })}
        description={t("page.description", { defaultValue: "The page you are looking for may have been moved, deleted, or the URL was typed incorrectly." })}
        breadcrumb={breadcrumb}
      >
        {content}
      </PageHeader>
    </>
  );
}
